import { render, staticRenderFns } from "./ObjectControl.vue?vue&type=template&id=60e84090&"
import script from "./ObjectControl.vue?vue&type=script&lang=js&"
export * from "./ObjectControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports